import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-confirm-campagne',
  templateUrl: './dialog-confirm-campagne.component.html',
  styleUrls: ['./dialog-confirm-campagne.component.scss']
})
export class DialogConfirmCampagneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
